import getEnv from '@lcai/console-env';
export default function getUrlBase() {
  var env = getEnv();
  switch (env) {
    case 'test':
    case 'dev':
      return 'https://testapi.liangceai.net/admin-api';
    default:
      return 'https://api.liangceai.net/admin-api';
  }
}
//# sourceMappingURL=get-url-base.js.map